<form [formGroup]="form" *ngIf="form">
  <div [dir]="data.dir" class="row">
    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.clause" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="clause"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-6 date mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.startDate" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="startPicker" (click)="startPicker.open()" formControlName="startDate"
          [max]="form.controls.endDate.value" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-sm-6 date mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.endDate" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="endPicker" (click)="endPicker.open()" formControlName="endDate"
          [min]="form.controls.startDate.value" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.responsibleName" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="responsibleName" />
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.responsiblePosition" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="responsiblePosition" />
      </mat-form-field>
    </div>

    <div class="col-sm-12 mt-2 d-flex justify-content-end">
      <button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
        {{ "forms.common.cancel" | translate }}
      </button>
      <button *ngIf="!data.viewOnly" mat-flat-button (click)="save()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </div>
</form>